import { useQuery } from '@tanstack/react-query'

import { StaleTime } from '@core/query'
import { AudioPlayerQueryKey } from '../helpers/queryKeys'

import { getAudioPeaks } from '../services/getAudioPeaks'

export const useAudioPeaks = ({
    audioId,
    sourceId,
    peaksUrl,
    enabled,
}: {
    audioId: string
    sourceId: string
    peaksUrl: string
    enabled: boolean
}) => {
    return useQuery({
        queryKey: AudioPlayerQueryKey.audioPeaks(audioId, sourceId),
        queryFn: ({ signal }) => getAudioPeaks(peaksUrl, signal),
        staleTime: StaleTime.Long,
        enabled,
    })
}
